import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Document } from '../models/document';

@Injectable({
  providedIn: 'root',
})
export class DocumentUploadService {
  private apiUrl = environment.APP_BASE_URL + '/doctor-portal/documents';

  constructor(private http: HttpClient) {}

  uploadFile(file: File, type: string | null): Observable<Document> {
    const formData = new FormData();
    formData.append('file', file);

    if (!!type) {
      formData.append('documentType', type);
    }

    return this.http.post<Document>(`${this.apiUrl}/upload`, formData);
  }

  uploadDocument(formData: FormData, type: string | null): Observable<Document> {
    if (!!type) {
      formData.append('documentType', type);
    }

    return this.http.post<Document>(`${this.apiUrl}/upload`, formData);
  }

  downloadDocument(appointmentId: string | null | undefined, documentId: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.apiUrl}/download/${appointmentId}/${documentId}`, {
      responseType: 'blob' as 'json',
    });
  }

  deleteDocument(appointmentId: string | null | undefined, documentId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${appointmentId}/${documentId}`);
  }
}
